export const AWAIT_RECENT_ENTITIES_STORAGE_KEY = "await_recent_entity_ids";

export const AWAIT_RECENT_ENTITIES_LIMIT = 3;

export const decodeStoredAwaitRecentEntityIds = (stored: string | null): Array<string> => {
    if (stored === null) {
        return [];
    }

    try {
        const parsed: unknown = JSON.parse(stored);
        return Array.isArray(parsed)
            ? parsed.filter((id): id is string => typeof id === "string")
            : [];
    } catch {
        return [];
    }
};

export const addAwaitRecentEntityId = (
    existing: Array<string>,
    awaitableEntityId: string,
): Array<string> =>
    [awaitableEntityId, ...existing.filter((id) => id !== awaitableEntityId)]
        .slice(0, AWAIT_RECENT_ENTITIES_LIMIT);

export const getPersistedAwaitRecentEntityIds = (): Array<string> =>
    decodeStoredAwaitRecentEntityIds(localStorage.getItem(AWAIT_RECENT_ENTITIES_STORAGE_KEY));

export const pushPersistedAwaitRecentEntityId = (awaitableEntityId: string): void =>
    localStorage.setItem(
        AWAIT_RECENT_ENTITIES_STORAGE_KEY,
        JSON.stringify(addAwaitRecentEntityId(getPersistedAwaitRecentEntityIds(), awaitableEntityId)),
    );
